import axios, { type AxiosResponse } from '@fs/zion-axios'
import { ROOTSTECH_SERVICE as SERVICE } from '../../serviceNames'
import { getLocaleConfig } from '../../helpers/requestConfig'

// DOCS: /service/rootstech/registration'

type RegistrationBody = Record<string, unknown>

const BASE = `${SERVICE}/registration`

export const DUPLICATE_REGISTRATION_STATUS = 409

export const register = async (body: RegistrationBody): Promise<AxiosResponse> =>
  axios.post(`${BASE}/vendor/rootstech`, body, getLocaleConfig())

export const registerForExpoHall = async (body: RegistrationBody): Promise<AxiosResponse> =>
  axios.post(`${BASE}/vendor/rootstech/expohall`, body, getLocaleConfig())

export const registerForARC = async (body: RegistrationBody): Promise<AxiosResponse> =>
  axios.post(`${BASE}/subscription/rootstech`, body, getLocaleConfig())

export const registerForDiscoveryDay = async (body: RegistrationBody): Promise<AxiosResponse> =>
  axios.post(`${BASE}/vendor/rootstech/discovery-day`, body, getLocaleConfig())

export const subscribe = async (body: RegistrationBody): Promise<AxiosResponse> =>
  axios.post(`${BASE}/vendor/rootstech/subscribe`, body, getLocaleConfig())

export const easyRegister = async (body: RegistrationBody): Promise<AxiosResponse> =>
  axios.post(`${BASE}/vendor/rootstech/easy-registration`, body, getLocaleConfig())

export const getSubscriptions = async (): Promise<AxiosResponse> =>
  axios.get(`${BASE}/vendor/rootstech/CURRENT/subscriptions-status`, getLocaleConfig())

export const getRegistrationStatus = async (): Promise<AxiosResponse> =>
  axios.get(`${BASE}/attendee/CURRENT/status`, getLocaleConfig())

export const updateSubscriptions = async (body: RegistrationBody): Promise<AxiosResponse> =>
  axios.put(`${BASE}/vendor/rootstech/preferences`, body, getLocaleConfig())
